import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FaBook, FaArrowLeft } from 'react-icons/fa'

const topics = [
  {
    name: 'बाग',
    image: 'https://botgo.s3.ap-south-1.amazonaws.com/62700601737526715140-bird.jpg'
  },
  {
    name: 'तालाब',
    image: 'https://botgo.s3.ap-south-1.amazonaws.com/71134451737526749671-comp.jpg'
  },
  {
    name: 'वर्णमाला गीत',
    image: 'https://botgo.s3.ap-south-1.amazonaws.com/53831191737527623024-cat.jpg'
  },
  {
    name: 'गिनो बताओ',
    image: 'https://botgo.s3.ap-south-1.amazonaws.com/34873991737527673046-bunny.jpg'
  }
  // {
  //   name: 'पशु और पक्षी',
  //   image: 'https://botgo.s3.ap-south-1.amazonaws.com/97474921737522730567-pashuPakshi.jpeg'
  // },
  // {
  //   name: 'संख्या',
  //   image: 'https://botgo.s3.ap-south-1.amazonaws.com/29028421737527717596-origami.jpg'
  // },
  // {
  //   name: 'जोड़',
  //   image: 'https://botgo.s3.ap-south-1.amazonaws.com/60601921737522834564-addition.jpg'
  // },
  // {
  //   name: 'घटाव',
  //   image: 'https://botgo.s3.ap-south-1.amazonaws.com/23051961737527760835-panda.jpeg'
  // },
  // {
  //   name: 'आकृतियां',
  //   image: 'https://botgo.s3.ap-south-1.amazonaws.com/51866051737527798769-bard.jpg'
  // }
]

const Lesson = () => {
  const navigate = useNavigate()
  return (
    <div className='d-flex flex-column justify-content-center align-items-center position-relative overflow-hidden'>
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className='btn btn-outline-light position-absolute top-0 start-0 m-3'
        style={{
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          padding: '10px 15px',
          fontSize: '1.5rem',
          border: 'none',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          zIndex: 1
        }}
      >
        <FaArrowLeft />
      </button>

      <h1 className='display-4 mb-4'>कक्षा 1 के विषय</h1>
      <div className='row row-cols-1 row-cols-md-5 p-5'>
        {topics.map((topic, index) => (
          <div className='col mt-4' key={topic.name}>
            <motion.div
              className='card border-0 shadow-lg'
              whileHover={{ scale: 1.05, boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)' }}
              onClick={() => navigate(`/learning/class1/${topic.name}`)}
              style={{
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '12px',
                transition: 'all 0.3s ease-in-out',
                height: '450px', // Fixed height for square shape
                width: '100%' // Full width
              }}
            >
              <div
                className='card-img-container'
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '450px', // Fixed height for the image container
                  overflow: 'hidden', // Ensures the image is cropped to fit
                  borderRadius: '12px 12px 0 0'
                }}
              >
                <img
                  src={topic.image}
                  className='card-img-top'
                  alt={topic.name}
                  style={{
                    objectFit: 'cover',
                    height: '100%',
                    width: '100%',
                    borderRadius: '12px 12px 0 0'
                  }}
                />
              </div>
              <div className='card-body'>
                <h5
                  className='card-title text-center fs-1'
                  // style={{
                  //   fontSize: '1.75rem', // Increase font size
                  //   fontWeight: 'bold', // Optional: make the font bold
                  //   marginBottom: '1rem'
                  // }}
                >
                  {topic.name}
                </h5>
                <button className='btn btn-info w-100 mt-3 fs-3 '>
                  <FaBook className='me-2' />
                  अधिक जानें
                </button>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Lesson
